import { all, fork } from 'redux-saga/effects';
import megaSagas from './mega/megaSagas';
import accountSaga from './my-system/auth/accountSaga';

export default function* rootSagas() {
	yield all([fork(accountSaga)]);
	yield all([fork(megaSagas)]);
}
